export default {
  example: {
    test: 'Language Test'
  },
  placeholder: {
    select: 'Please select',
    input: 'Please enter',
    upload: 'Please upload'
  }
}